import React, { useState } from "react";
import {
  Modal,
  Backdrop,
  Fade,
  Typography,
  IconButton,
  Button as MuiButton,
} from "@material-ui/core";
import { Box, Checkbox, Divider, Stack } from "@mui/material";
import Button from "../../Button";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import Warning from "@mui/icons-material/Warning";
import { Form } from "react-bootstrap";
import { colors } from "../../../utils";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Grid } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import {
  getDoNotShowDeletePopupAgainValue,
  setDoNotShowDeletePopupAgainValue,
} from "../../../utils/localStorageHelper";

const REMOVE_KEY_WORD = "DELETE";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "40%",
    maxHeight: "80%",
    overflowY: "auto",
    borderRadius: 10,
  },
}));

const DeleteConfirmationModal = ({
  isOpen,
  handleClose,
  onConfirm = () => {},
}) => {
  const classes = useStyles();
  const [isConfirmationText, setIsConfirmationText] = useState("");

  const showDeletePopup = getDoNotShowDeletePopupAgainValue();

  const [tempShowDeletePopup, setTempShowDeletePopup] =
    useState(showDeletePopup);

  const handleCheckboxChange = (event) => {
    setTempShowDeletePopup(event.target.checked); // Change local state only
  };

  const onConfirmPress = () => {
    // Persist checkbox value ONLY if Confirm was pressed
    if (tempShowDeletePopup !== showDeletePopup) {
      setDoNotShowDeletePopupAgainValue(tempShowDeletePopup);
    }
    onConfirm?.();
    setIsConfirmationText("");
    handleClose();
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        className={classes.modal}
        open={isOpen}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={isOpen}>
          <div className={classes.paper}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box display="flex" alignItems="center">
                <Warning
                  style={{ color: "rgba(245, 204, 59, 1)", marginRight: "8px" }}
                />
                <Typography
                  variant="h6"
                  id="transition-modal-title"
                  style={{
                    color: "#565556",
                    fontFamily: "DM Sans",
                    fontWeight: 700,
                    fontSize: "20px",
                    lineHeight: "20px",
                  }}
                >
                  Are you sure you want to remove access?
                </Typography>
              </Box>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                style={{ color: "#123051", width: "16px", height: "16px" }}
              >
                <CloseIcon />
              </IconButton>
            </Stack>
            <Divider sx={{ mt: 2 }} variant="middle" />
            <Box sx={{ mt: 2 }}>
              <span
                style={{
                  fontSize: 16,
                  color: "rgba(18, 48, 81, 1)",
                  fontFamily: "DM Sans",
                }}
              >
                To confirm your action, type in the word{" "}
                <span
                  style={{
                    fontSize: 16,
                    color: "rgba(18, 48, 81, 1)",
                    fontFamily: "DM Sans",
                    fontWeight: "bold",
                  }}
                >
                  '{REMOVE_KEY_WORD}'
                </span>{" "}
                below
              </span>
            </Box>

            <Box sx={{ mt: 2 }}>
              <Form.Control
                type="text"
                placeholder="Type here"
                value={isConfirmationText}
                onChange={(e) => setIsConfirmationText(e.target.value)}
              />
            </Box>

            <Box sx={{ mt: 2 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={tempShowDeletePopup}
                    onChange={handleCheckboxChange}
                    sx={{
                      color: colors.PrimaryPurple300,
                      "&.Mui-checked": {
                        color: colors.PrimaryPurple500,
                      },
                    }}
                  />
                }
                label="Do not show this again"
              />
            </Box>

            <Grid
              container
              spacing={1}
              sx={{ mt: 2, justifyContent: "flex-end", alignItems: "center" }}
            >
              <Grid item>
                <MuiButton variant="text" color="primary" onClick={handleClose}>
                  Cancel
                </MuiButton>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  onClick={onConfirmPress}
                  disabled={isConfirmationText !== REMOVE_KEY_WORD}
                >
                  Confirm
                </Button>
              </Grid>
            </Grid>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default DeleteConfirmationModal;
